import React, { Component } from 'react';
import './App.css';
import $ from 'jquery';


class Reference extends Component {
    constructor(props){
        super(props);

    }
    componentDidMount(){
        function resetMenu(){
            $("#home a").removeClass("active");
            $("#sluzby-a-produkty-link a").removeClass("active");
            $("#prodej-instalace-li a").removeClass("active");
            $("#lokalni-li a").removeClass("active");
            $("#outsourcing-li a").removeClass("active");
            $("#audit-is-li a").removeClass("active");
            $("#webhosting-li a").removeClass("active");
            $("#webdesign-li a").removeClass("active");
            $("#cenik-praci-li a").removeClass("active");

            $("#o-firme-li a").removeClass("active");
            $("#reference-li a").removeClass("active");
            $("#kontakty-li a").removeClass("active");
            $("#podpora-li a").removeClass("active");
        }

        resetMenu();

        $("#reference-li a").addClass("active");
    }
  render() {
    return (
<div>


        <div className="container content fade-in two" id="reference">
            <h1>Reference</h1>


            <h2>Našich služeb a dodané výpočetní techniky využívají tito naši významní zákazníci:</h2>



            <div className="col-sm-6">
                <span>
                   MO Atelier s. r. o.<br/>
Agile Consulting Engineers s.r.o.<br/>
KLIMAMONT KOPELENT, s.r.o.<br/>
TC ing s.r.o.<br/>
PP Engineering Services s.r.o.<br/>
Divadelní catering s.r.o.<br/>
MO-TA s.r.o.<br/>
VIMSTAV s.r.o.<br/>
OLYMPIA project s.r.o.<br/>
LARGUS s.r.o.<br/>
KOLOS Praha s.r.o.<br/>
Gastro KORKORÁN s.r.o.<br/>
České hnutí speciálních olympiád<br/>
JURISGEO, s.r.o.
                </span>
            </div>

            <div className="col-sm-4">
                <span>
                 Kamenictví Procházka s.r.o.<br/>
MARILON s.r.o.<br/>
UNIVERS, spol. s r.o.<br/>
PAKO-Z s.r.o.<br/>
ARIT s.r.o.<br/>
ComKo s.r.o.<br/>
Ing. Tanasis AVUKATOS<br/>
Ing. Ptáčková Alena<br/>
Ing. Jan Moravec<br/>
JUDr. Wawerka Karel<br/>
JUDr. Wawerková Magdaléna<br/>
Adel Studio<br/>
BW Servis Rataj Petr<br/>
                    a další ...
                </span>
            </div>






        </div>


</div>
    );
  }
}

export default Reference;



// WEBPACK FOOTER //
// ./src/Reference.js